module.exports = __webpack_public_path__ + "static/media/underwaterBase.9e001f91.png";